import cn from 'classnames'
import { FunctionComponent } from 'react'
import { Button } from '@/components/Button'
import { CalculatorStore } from '@/store/Calculator'
import styles from './Price.module.scss'

interface PriceProps {
  className?: string
  store: CalculatorStore
}
export const Price: FunctionComponent<PriceProps> = ({ className, store }) => {
  return (
    <div className={cn(className, styles.container)}>
      <div className={styles.group}>
        <div className={styles.header}>
          <div className={styles.title}>Стоимость услуг</div>
        </div>

        <div className={styles.list}>
          <div className={styles.item}>
            <div className={styles.row}>
              <div className={styles.description}>
                Вы выбрали Тариф “{store.tariffName}”
              </div>
              <div className={styles.price}>{store.formatTariffPrice} ₽</div>
            </div>
          </div>
          {store.isAccelerated ? (
            <div className={styles.item}>
              <div className={styles.row}>
                <div className={styles.description}>
                  Услуги по ускоренной процедуре регистрации{' '}
                </div>
                <div className={styles.price}>
                  {store.formatAcceleratedServicePrice} ₽
                </div>
              </div>
            </div>
          ) : null}
        </div>
        <div className={styles.footer}>
          <div className={styles.groupResult}>
            Стоимость наших услуг: {store.formatTotalServicePrice} ₽
          </div>
        </div>
      </div>

      <div className={styles.group}>
        <div className={styles.header}>
          <div className={styles.title}>Размер госпошлины</div>
        </div>
        {store.countClasses === 0 ? (
          <>
            Для расчета госпошлины подберите классы МКТУ
            <Button href="/mktu" className={styles.mktuLink} variant="tertiary">
              Подобрать
            </Button>
          </>
        ) : (
          <>
            <div className={styles.list}>
              <div className={styles.item}>
                <div className={styles.row}>
                  <div className={styles.description}>
                    Пошлина Роспатента при подаче заявки на регистрацию ТЗ
                  </div>
                  <div className={styles.price}>
                    {store.formatTaxForClasses} ₽
                  </div>
                </div>
              </div>
              {store.isAccelerated ? (
                <div className={styles.item}>
                  <div className={styles.row}>
                    <div className={styles.description}>
                      Пошлина Роспатента за ускорение процедуры регистрации
                    </div>
                    <div className={styles.price}>
                      {store.formatAcceleratedTax} ₽
                    </div>
                  </div>
                </div>
              ) : null}
              <div className={styles.item}>
                <div className={styles.row}>
                  <div className={styles.description}>
                    <div className={styles.secondary}>
                      {store.isAccelerated ? 'через 2 мес.' : 'через 6-12 мес.'}
                    </div>
                    Пошлина Роспатента при выдаче свидетельства на ТЗ
                  </div>
                  <div className={styles.price}>
                    {store.formatTaxCertificate} ₽
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.footer}>
              <div className={styles.groupResult}>
                Общая стоимость пошлин: {store.formatTotalTax}&nbsp;₽
              </div>
            </div>
          </>
        )}
      </div>

      {store.countClasses !== 0 ? (
        <div className={styles.result}>
          Общая стоимость: {store.formatResultSum}&nbsp;₽
        </div>
      ) : null}
    </div>
  )
}
